<template>
  <div>
    <div class="a-tab__title-block admin__a-tab">
      <h3>{{$t('form.lot.list-of-position')}}</h3>
    </div>

    <div class="a-container-form admin-buy__location-end ">
<!--      <button class="gui-btn gui-btn&#45;&#45;red gui-btn&#45;&#45;w-207" @click.prevent="downloadTemplate">{{$t('buttons.download-template')}}</button>-->
      <file-picker :accept="['xlsx', 'xls']"
                   :signing="false"
                   :label="'buttons.upload'"
                   @prepared="uploadSpecificationAndPayments"
                   v-if="canEditFull">
      </file-picker>
      <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="downloadSpecification">{{$t('buttons.download-org-template')}}</button>
      <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="downloadRequestTemplate">{{$t('buttons.download-request-template')}}</button>
    </div>

    <div class="admin-buy__block ">
      <specifications-table :lot="lot"
                            :specs="lot.specs"
                            :number-of-parts="lot.numberOfParts"
                            :permissions="lot.permissions"
                            :validate-parts="canConfigureParts">
      </specifications-table>
    </div>
  </div>
</template>

<script>
  import PermissionsMixins from '../mixins/permissions'
  import CommonMixins from '../mixins/common'
  import SpecificationsTable from "./SpecificationTable";

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    },

    components: {
      SpecificationsTable
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    computed: {
      canConfigureParts() {
        return (this.lot.methods.actual.valid && !this.lot.methods.actual.REDUCTION) || !this.lot.methods.planned.REDUCTION;
      }
    },

    methods: {
      async downloadTemplate() {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('downloadTemplate', {
              id: this.lot.id,
              filename: `lot-${this.lot.id}-template`
            });
          }
          catch (e) {
            console.error('unable to download specification template', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async downloadRequestTemplate() {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('downloadRequestTemplate', {
              id: this.lot.id,
              filename: `lot-${this.lot.id}-request-template`
            });
          }
          catch (e) {
            console.error('unable to download specification template', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async downloadSpecification() {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('downloadSpecification', {
              id: this.lot.id,
              filename: `lot-${this.lot.id}-specification`
            });
          }
          catch (e) {
            console.error('unable to download specification template', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async uploadSpecificationAndPayments(file) {
        this.runBlockerAction(async() => {
          try {
            const lot = await this.$store.dispatch('uploadSpecificationAndPayments', {
              id: this.lot.id,
              file
            });

            this.checkForm(lot);
          }
          catch(e) {
            console.error('unable to upload specification template', e);
            this.globalErrorHandler(e);
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
